import { useEffect, useState } from 'react'

let portalContainer: HTMLElement | null = null
let portalRefCount = 0

const usePortalContainer = () => {
  const [container, setContainer] = useState<HTMLElement | null>(null)

  useEffect(() => {
    if (!portalContainer) {
      portalContainer = document.createElement('div')
      Object.assign(portalContainer.style, {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: '1000',
      })

      document.body.append(portalContainer)
    }
    portalRefCount++
    setContainer(portalContainer)

    return () => {
      portalRefCount--
      if (portalRefCount === 0) {
        portalContainer?.remove()
        portalContainer = null
      }
    }
  }, [])

  return container
}

export default usePortalContainer
